import { Helmet } from "react-helmet-async";
import { StepperItem, Layout, Button, Input, Dropdown, TableRowResponsive, CustomSelect, CustomSearch, StepperItemMobile, StepperItemMobileUpdate, CustomModal, DatePickerInput } from "../../components";
import { UitlinkController } from "../../controllers";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import { Add, ArrowBack, Arrowdown2, Arrowleft, Calendar3, Cancel, CardTransfer, ChatSquare, CircleTick, Forward, GraphNewUp, History, Import, Money, ReplyPic, SquareTransferVertical, Star, Tick, User } from "../../../assets";
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, Dialog, FormControlLabel , Pagination, PaginationItem , Slide } from "@mui/material";
import "chart.js/auto";
import { Line } from "react-chartjs-2";
import { TransitionProps } from '@mui/material/transitions';
import React from "react";
import { numberWithCommas } from "../../../core/utils";
import { connect } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import routes from "../../../core/routes";
import { toast } from "react-toastify";
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class Uitlink extends UitlinkController {
    componentDidMount() {
        window.scrollTo(0, 0);
        if (window.location.pathname.split("/")[2]) {
            this.getDefaultInquery();
        }
    }
    render() {
        const { openMenu, showInfo, limitationInquiry, extrarisk, jobListHolder, jobListInquiry,
            saveing, payment_duration, duration,
            adjustment_coefficient_death_benefit, adjustment_coefficient_permium, decuple_coverages_premium,
            premium_annually, has_cancer_diagnosis, cancer_coverage,
            has_supplementary_special_diseases_coverage, accident_medical_cost_coverage,
            temporary_and_permanent_disability_coverage,
            has_hos_benefit_coverage,
            annuity_disability_coverage_disease, main_special_diseases_coverage,
            annuity_disability_coverage_accident,
            has_temporary_disability_coverage,
            start_death_asset,
            accident_death_coverage,
            step1Errors,
            step2Errors,
            step3Errors,
            payment_method,
            paymentMethodList,
            step,
            contentLoading,
            has_waiver_diseases_policy_holder,
            has_waiver_accident_policy_holder,
            result,
            currentPage,
            showUpdateMOdal,
            jobListHolderLoading,
            jobListInquiryLoading,
            step4Errors,
            life_bens,
            relationPersonList,
            step5Errors,
            project_id,
            percent,
            openBeneficiaryModal,
            settings,
            contract_id,
            base64Loading
            
        } = this.state;
        return (
            <Layout title=" استعلام بیمه زندگی متصل به
صندوق های بازار سرمایه  ">
                <Helmet>
                    <title>  استعلام بیمه  | بیمه زندگی هامرز </title>
                </Helmet>

                <div className={`${step === 6 ? "pt-0 h-100" : ""} inquery scrollbar hide-mobile`}>


                    <div className="inquery-container ">

                        {step === 6 ?
                            <>
                                <div className={openMenu ? "drawer-menu-container inquery-stepper" : "inquery-drawer"} onClick={() => this.setState({ openMenu: !openMenu })}>
                                    {openMenu &&
                                        <div className="stepper-container">
                                            <StepperItem latestStep="cursor-pointer" onClick={() => this.setState({ step: 1 })} stepTitle="مرحله اول" stepDesc="اطلاعات هویتی  " step={1} activeStep={step} />
                                            <StepperItem latestStep="cursor-pointer" onClick={() => this.setState({ step: 2 })} stepTitle="مرحله دوم" stepDesc="اطلاعات بیمه نامه" step={2} activeStep={step} />
                                            <StepperItem latestStep="cursor-pointer" onClick={() => this.setState({ step: 3 })} stepTitle="مرحله سوم" stepDesc="پوشش های بیمه ای" step={3} activeStep={step} >
                                                <div className="step-in-step">
                                                    {/* active-step-title */}
                                                    <span onClick={() => this.setState({ step: 3 })} className={`step-title active-step-title cursor-pointer mt-2`}>
                                                        1.  پوشش های بیمه شده (12مورد)
                                                    </span>
                                                    <span onClick={() => this.setState({ step: 4 })} className={`step-title active-step-title cursor-pointer mt-2`}>
                                                        2.   پوشش های بیمه گذار (مورد 2)
                                                    </span>

                                                </div>
                                            </StepperItem>
                                            <StepperItem latestStep="cursor-pointer" onClick={() => this.setState({ step: 5 })} stepTitle="مرحله چهارم" stepDesc="نحوه ی سرمایه گذاری" step={5} activeStep={step} />

                                            <StepperItem latestStep="cursor-pointer" onClick={() => this.setState({ step: 6 })} stepTitle="مرحله پنجم" stepDesc=" مشاهده نتیجه استعلام " step={6} activeStep={step} />
                                        </div>
                                    }
                                    <div className={`${openMenu ? "left" : "position-fixed"} inquery-circle-menu`} ><Arrowleft myStyle={openMenu ? "rotate-180" : ""} color="#ffffff" /></div>
                                </div>
                            </>

                            :

                            <div className="inquery-stepper hide-mobile">
                                <div className="stepper-container">
                                    <StepperItem stepTitle="مرحله اول" stepDesc="اطلاعات هویتی  " step={1} activeStep={step} />
                                    <StepperItem stepTitle="مرحله دوم" stepDesc="اطلاعات بیمه نامه" step={2} activeStep={step} />
                                    <StepperItem stepTitle="مرحله سوم" stepDesc="پوشش های بیمه ای" step={3} activeStep={step} >
                                        <div className="step-in-step">
                                            {/* active-step-title */}
                                            <span className={`step-title ${this.state.step === 3 || this.state.step > 3 ? "active-step-title" : ""} mt-2`}>
                                                1.  پوشش های بیمه شده (12مورد)
                                            </span>
                                            <span className={`step-title ${this.state.step === 4 || this.state.step > 4 ? "active-step-title" : ""} mt-2`}>
                                                2.   پوشش های بیمه گذار (مورد 2)
                                            </span>

                                        </div>
                                    </StepperItem>
                                    <StepperItem stepTitle="مرحله چهارم" stepDesc="نحوه ی سرمایه گذاری" step={5} activeStep={step} />
                                    <StepperItem stepTitle="مرحله پنجم" stepDesc=" مشاهده نتیجه استعلام " step={6} activeStep={step} />
                                </div>
                            </div>
                        }
                        {step === 6 ?
                            <div className="inquery-result-container">
                                <div className="inquery-result">
                                    <div className="inquery-result-data">

                                        <div className="info">
                                            <div>
                                                <div className="out-side ">

                                                    <span className="  data-title">
                                                        استعلام حق بیمه
                                                    </span>
                                                    <div className="out-side-data-item data-item">
                                                        <span className="title ">
                                                            مدت بیمه نامه
                                                        </span>
                                                        <span className="description primary-title">
                                                            {duration} سال
                                                        </span>

                                                    </div>
                                                    <div className="out-side-data-item data-item">
                                                        <span className="title ">
                                                            نحوه پرداخت حق بیمه
                                                        </span>
                                                        <span className="description primary-title">
                                                            {paymentMethodList.find((x: { value: any; }) => x.value === payment_method)?.title}
                                                        </span>

                                                    </div>
                                                    <div className="out-side-data-item data-item">
                                                        {payment_method !== 0 &&
                                                            <>
                                                                <span className="title ">
                                                                    مدت پرداخت حق بیمه
                                                                </span>
                                                                <span className="description primary-title">
                                                                    {payment_duration} سال
                                                                </span>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="data-items">
                                                    {payment_method !== 0 &&
                                                        <div className="data-item">
                                                            <span className="title ">
                                                                مبلغ آورده اولیه
                                                            </span>
                                                            <span className="description">
                                                                {numberWithCommas(saveing)} ریال 
                                                            </span>

                                                        </div>
                                                    }
                                                    {payment_method !== 0 &&
                                                        <div className="data-item">
                                                            <span className="title">
                                                            افزایش سالانه حق بیمه 
                                                            </span>
                                                            <span className="description">
                                                                {adjustment_coefficient_permium} درصد
                                                            </span>
                                                        </div>
                                                    }
                                                    <div className="data-item">
                                                        <span className="title">
                                                            افزایش سالانه سرمایه فوت
                                                        </span>
                                                        <span className="description">
                                                            {adjustment_coefficient_death_benefit} درصد
                                                        </span>

                                                    </div>
                                                    <div className="data-item">
                                                        <span className="title">
                                                            پوشش فوت   حادثه
                                                        </span>
                                                        <span className="description">
                                                            {accident_death_coverage} برابر
                                                        </span>

                                                    </div>
                                                    <div className="data-item">
                                                        <span className="title">
                                                            پوشش نقص عضو
                                                        </span>
                                                        <span className="description">
                                                            {temporary_and_permanent_disability_coverage} درصد
                                                        </span>

                                                    </div>
                                                    <div className="data-item">
                                                        <span className="title">
                                                           غرامت روزانه بستری
                                                        </span>
                                                        <span className="description">
                                                            {has_hos_benefit_coverage ? "بله" : "خیر"}
                                                        </span>

                                                    </div>
                                                    <div className="data-item">
                                                        <span className="title">
                                                            غرامت روزانه عمومی                                                </span>
                                                        <span className="description">
                                                            {has_temporary_disability_coverage ? "بله" : "خیر"}
                                                        </span>

                                                    </div>
                                                    <div className="data-item">
                                                        <span className="title">
پرداخت مستمری ازکارافتادگی دائم 
                                                        </span>
                                                        <span className="description">
                                                            حادثه {annuity_disability_coverage_accident} درصد | بیماری {annuity_disability_coverage_disease} درصد
                                                        </span>

                                                    </div>
                                                    <div className="data-item">
                                                        <span className="title">
                                                            پوشش امراض خاص
                                                        </span>
                                                        <span className="description">
                                                            اصلی: {main_special_diseases_coverage} درصد  | تکمیلی: {has_supplementary_special_diseases_coverage ? "بله" : "خیر"}
                                                        </span>

                                                    </div>
                                                    {payment_method !== 0 &&
                                                        <div className="data-item">
                                                            <span className="title">
                                                                پوشش معافیت از پرداخت حق بیمه
                                                            </span>
                                                            <span className="description">
                                                                حادثه: {has_waiver_accident_policy_holder ? "بله" : "خیر"} | بیماری : {has_waiver_diseases_policy_holder ? "بله" : "خیر"}
                                                            </span>

                                                        </div>
                                                    }
                                                    <div className="data-item">
                                                        <span className="title">
                                                           بیماری سرطان
                                                        </span>
                                                        <span className="description">
                                                            {cancer_coverage} درصد
                                                        </span>

                                                    </div>
                                                    <div className="data-item">
                                                        <span className="title">
                                                            هزینه تشخیص سرطان </span>
                                                        <span className="description">
                                                            {has_cancer_diagnosis ? "بله" : "خیر"}
                                                        </span>

                                                    </div>
                                                    {payment_method === 0 &&
                                                        <>

                                                            <div className="data-item">
                                                                <span className="title">
                                                        پرداخت جداگانه‌ی حق بیمه پوشش‌های بیمه‌ای

                                                                </span>
                                                                <span className="description">
                                                                    {decuple_coverages_premium ? "بله" : "خیر"}
                                                                </span>
                                                            </div>
                                                        </>
                                                    }


                                                    <div className="data-item">
                                                        <span className="title">
                                                            صندوق
                                                        </span>
                                                        {life_bens && life_bens.length > 0 && life_bens?.map((item: any, index: number) => (
                                                            <>
                                                                <span className="description">
                                                                    {relationPersonList?.find((element: { value: any; }) => element?.value === item?.project_id)?.title || "---"} :
                                                                    {item?.percent || "---"} {" "} %
                                                                </span>
                                                            </>
                                                        )
                                                        )}
                                                    </div>
                                                    {payment_method === 0 &&
                                                        <div className="data-item">
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="info-chart">
                                                <div className="info-chart-headline">
                                                    <span className="title">
                                                        رشد اندوخته
                                                    </span>

                                                    <div className="d-flex">
                                                        <div className="roshd">
                                                            <span className="roshd-badge t"></span>
                                                            <span className="roshd-title">  رشد تضمینی (ریال)</span>

                                                        </div>
                                                        <div className="roshd me-3">
                                                            <span className="roshd-badge p"></span>
                                                            <span className="roshd-title">  رشد پیش بینی شده (ریال)</span>

                                                        </div>
                                                    </div>
                                                </div>


                                                <Line
                                                    data={this.state.data}

                                                    options={this.state.options}
                                                />
                                            </div>
                                        </div>

                                    </div>


                                    {/* <div className="inquery-result-chart"> */}
                                </div>
                                <div className="policy w-100 table-responsive custom-scrollbar  mt-2">
                                    <table className="table hide-mobile">
                                        <thead>
                                            <tr>

                                                <th scope="col">سال</th>
                                                <th scope="col">سن </th>
                                                <th scope="col">  {payment_method === 0 ? "حق بیمه  یکجا" : "حق بیمه سالیانه "}</th>
                                                <th scope="col"> سرمایه فوت</th>
                                                <th scope="col">سرمایه فوت حادثه</th>
                                                <th scope="col">سرمایه نقص عضو</th>

                                                <th scope="col">سرمایه هزینه پزشکی</th>
                                                <th scope="col">بیماری خاص اصلی</th>
                                                <th scope="col">سرمایه بیماری سرطان </th>
                                                <th scope="col">بازخریدی (تضمینی) </th>
                                                <th scope="col">بازخریدی (پیشبینی) </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {result?.result?.slice(currentPage * 5, currentPage * 5 + 5)
                                                ?.map((item: any, index: number) => (

                                                    // {result?.map((item: any, index: number) => {
                                                    //     return (
                                                    <tr>
                                                        <th dir="ltr">{item?.term_year}</th>
                                                        <th dir="ltr">{item?.age}</th>
                                                        <th dir="ltr">{numberWithCommas(item?.pre_annually)}</th>
                                                        <th dir="ltr">{numberWithCommas(item?.death_benefit)}</th>
                                                        <th dir="ltr"> {numberWithCommas(item?.acc_death_benefit)}</th>
                                                        <th dir="ltr">{numberWithCommas(item?.acc_dis_benefit)}</th>
                                                        <th dir="ltr">{numberWithCommas(item?.acc_med_exp_benefit)}</th>
                                                        <th dir="ltr">{numberWithCommas(item?.critical_main_benefit)}</th>
                                                        <th dir="ltr">{numberWithCommas(item?.cancer_benefit)}</th>
                                                        <th dir="ltr">{numberWithCommas(item?.guaranteed_reserve)}</th>
                                                        <th dir="ltr">{numberWithCommas(item?.forecast_redeem_value)}</th>
                                                    </tr>
                                                )
                                                )}
                                        </tbody>
                                    </table>


                                    <div className="d-flex justify-content-between w-100">
                                    <div className="d-flex">

                                        {result?.universal_offer ?
                                        <Button myStyle="bg-green next-btn" title="ثبت پیشنهاد بیمه نامه"  link={window.location.pathname.split("/")[2] ? `${routes?.UNITLINKISSUING}/${window.location.pathname.split("/")[2]}` : routes.UNITLINKISSUING} />


                                        :
                                        <Button myStyle=" bg-green next-btn" title="ثبت پیشنهاد بیمه نامه" onClick={() => toast.error("با توجه به منفی شدن ارزش بازخرید , خواهشمند است نسبت به افزایش حق بیمه یا کاهش تعهدات اقدام فرمایید . ")} />


                                    }
                                    <Button loading={base64Loading} icon={Import} myStyle="replay bg-blue next-btn loading-spinner-primary " title="چاپ جدول تعهدات" onClick={()=>this.downloadPdf()} />

                                            </div>

                                        <Pagination
                                            className="custom-pagination "
                                            count={result?.result ? Math.ceil(result?.result?.length / 5) : 1}
                                            onChange={this.handleChangePage}
                                            size="small"
                                            page={currentPage + 1}
                                            renderItem={(item) => (
                                                <PaginationItem
                                                    slots={{ previous: Forward, next: ArrowBack }}
                                                    {...item}
                                                />
                                            )}
                                        />



                                    </div>
                                </div>
                            </div>
                            :
                            <div className="inquery-content">
                                <>
                                    {/* {step !== 6 &&
                                        <div>
                                            {contentLoading ? <>
                                                <div className="content-loading"></div>
                                                <div className="content-loading mt-2"></div>
                                            </> :
                                                <>
                                                    <span className="inquery-title">
                                                        استعلام بیمه نامه
                                                    </span>
                                                    <p className="inquery-description">
                                                        اطلاعات زیر را جهت استعلام بیمه نامه تکمیل نمایید.
                                                    </p>
                                                </>
                                            }
                                        </div>

                                    } */}

                                    {step === 1 &&
                                        <div className="inquery-form">
                                             {contentLoading ? <div className="content-loading"></div> :
                                                <span className="inquery-section-title">
                                                    قرارداد
                                                </span>
                                            }
                                            <div className="row-container ">

                                            <Input hasNotice="درصورت داشتن شماره قرارداد آن را وارد نمایید، درغیر این صورت چیزی ننویسید." disabled={window.location.pathname.split("/")[2] ? true : false} contentLoading={contentLoading} lable="شماره قرارداد" error={step1Errors.filter((name: { path: string; }) => name.path === "contract_id")?.[0]?.errors?.[0]} hideEndAdornment type="number" endAdornment="" max="10" myStyle="inquery-input w-48"  value={contract_id} onChange={(e: any) => this.setState({ contract_id: e })} />

                                          </div>

                                            {contentLoading ? <div className="content-loading"></div> :
                                                <span className="inquery-section-title">
                                                    اطلاعات هویتی بیمه گذار
                                                </span>
                                            }
                                            <div className="row-container ">
                                                <div className="w-48">
                                                    <DatePickerInput
                                                        iconBorder
                                                        ref={this.datePickerRefHolder}

                                                        contentLoading={contentLoading}
                                                        error={step1Errors.filter((name: { path: string; }) => name.path === "holder_birthday")?.[0]?.errors?.[0]}
                                                        // emptyState={() => this.setState({ holder_birthday: "" })}
                                                        disabled
                                                        value={this.state.holder_birthday}
                                                        onChange={this.handleChangeHolderBD}
                                                        isRequired hideEndAdornment
                                                        myStyle="inquery-input mb-0"
                                                        calendarPosition="bottom-right"
                                                        containerClassName="date-picker-container w-100"
                                                        inputClass="date-picker-input"
                                                        lable="تاریخ تولد"
                                                        icon={<img src={Calendar3} alt="هامرز" />}
                                                        maxDate={new DateObject({ calendar: persian }).subtract(18, "years")}

                                                    />

                                                </div>
                                                {/* <Dropdown objectList error={step1Errors.filter((name: { path: string; }) => name.path === "policy_holder_job_category")?.[0]?.errors?.[0]} items={jobListHolder}  displayEmpty myStyle="inquery-dropdown 
                                                        onChange={(event: any) => this.changeJobHolder(event.target.value)} icon={<img src={User} alt="هامرز" />} /> */}
                                                <CustomSearch hasNotice="درصورت داشتن چندین شغل خواهشمند است شغلی که عمده درآمد خود را از آن کسب می‌کنید، انتخاب نمایید." contentLoading={contentLoading} loading={jobListHolderLoading} error={step1Errors.filter((name: { path: string; }) => name.path === "policy_holder_job_category")?.[0]?.errors?.[0]} iconBorder icon={<img src={User} alt="هامرز" />} lable="شغل  " isRequired search={(e: any) => this.getJobHolder(e)} value={this.state.policy_holder_job_category} title={this.state.policy_holder_job_category_title} item={jobListHolder} myStyle="w-48" placeholder="انتخاب کنید" onChange={(event: any) => this.changeJobHolder(event)} />

                                            </div>
                                            <div className="title-check-container">

                                                {contentLoading ? <div className="content-loading"></div> :
                                                    <>
                                                        <span className="inquery-section-title">
                                                            اطلاعات هویتی بیمه شده
                                                        </span>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox checked={this.state.selfsame} onChange={(e: any) => this.selfsame(e)} name="selfsame" sx={{
                                                                    // color: "#155a9e",
                                                                    borderRadius: "3px",
                                                                    width: "23px",
                                                                    height: "23px",
                                                                    '&.Mui-checked': {
                                                                        // color: "#155a9e",
                                                                        borderRadius: "3px",
                                                                        width: "23px",
                                                                        height: "23px",
                                                                    },
                                                                    '&.MuiCheckbox-root': {
                                                                        padding: 0
                                                                    }
                                                                }} />
                                                            }
                                                            label="بیمه گذار و بیمه شده یک شخص واحد می باشد."
                                                        />

                                                    </>
                                                }

                                            </div>
                                            <div className="row-container ">
                                                <div className="w-48">
                                                    <DatePickerInput
                                                        iconBorder
                                                        ref={this.datePickerRefInsured}

                                                        contentLoading={contentLoading}
                                                        emptyState={() => this.setState({ insured_birthday: "" })}
                                                        error={step1Errors.filter((name: { path: string; }) => name.path === "insured_birthday")?.[0]?.errors?.[0]}
                                                        value={this.state.insured_birthday}
                                                        onChange={this.handleChangeInsuredBD}
                                                        isRequired hideEndAdornment
                                                        myStyle="inquery-input mb-0"
                                                        lable="تاریخ تولد"
                                                        calendarPosition="bottom-right"
                                                        containerClassName="date-picker-container w-100"
                                                        inputClass="date-picker-input"
                                                        icon={<img src={Calendar3} alt="هامرز" />}
                                                        maxDate={new DateObject({
                                                            calendar: persian,
                                                        })}
                                                    />

                                                </div>
                                                <CustomSearch hasNotice="درصورت داشتن چندین شغل خواهشمند است شغلی که عمده درآمد خود را از آن کسب می‌کنید، انتخاب نمایید." contentLoading={contentLoading} loading={jobListInquiryLoading} error={step1Errors.filter((name: { path: string; }) => name.path === "insured_job_category")?.[0]?.errors?.[0]} iconBorder icon={<img src={User} alt="هامرز" />} lable="شغل  " isRequired search={(e: any) => this.getJobInquiry(e)} value={this.state.insured_job_category} title={this.state.insured_job_category_title} item={jobListInquiry} myStyle="w-48" placeholder="انتخاب کنید" onChange={(event: any) => this.changeJobInsured(event)} />
                                                {/* <Dropdown objectList error={step1Errors.filter((name: { path: string; }) => name.path === "insured_job_category")?.[0]?.errors?.[0]} items={jobListInquiry} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-30"  placeholder="  انتخاب کنید " value={this.state.insured_job_category}
                                                        onChange={(event: any) => this.changeJobInsured(event.target.value)}
                                                        icon={<img src={User} alt="هامرز" />} /> */}


                                            </div>
                                        </div>
                                    }
                                    {step === 2 &&
                                        <>
                                            <div className="inquery-form inquery-wrap-form">
                                                {/* <div className="row-container justify-content-center"> */}
                                                    <Dropdown disabled={window.location.pathname.split("/")[2] ? true : false} objectList items={paymentMethodList} error={step2Errors.filter((name: { path: string; }) => name.path === "payment_method")?.[0]?.errors?.[0]} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-48" lable="نحوه پرداخت حق بیمه " placeholder="  انتخاب کنید " value={payment_method} onChange={(e: any) => this.handleChangePayment(e)} icon={<img src={ChatSquare} alt="هامرز" />} />

                                                {/* </div> */}
                                                {/* <div className="row-container "> */}
                                                    <Input  hideWhenDisabled                                            hasNotice={payment_method === 0 ? "میزان حق‌بیمه‌ای که توان و تمایل پرداخت آن را به‌صورت یکجا دارید در این قسمت وارد نمایید." : "میزان حق‌بیمه‌ای که در طول یک سال، توان و تمایل پرداخت آن را دارید در این قسمت وارد نمایید."}
 hasComma error={step2Errors.filter((name: { path: string; }) => name.path === "premium_annually")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="ریال" iconBorder icon={<Money />} myStyle="inquery-input w-48" lable={payment_method === 0 ? "حق بیمه  یکجا   " : "حق بیمه سال اول   "} value={premium_annually} onChange={(e: any) => this.setState({ premium_annually: e })} />
                                                    <Input hideWhenDisabled disabled={payment_method === 0 ? true : false} hasComma error={step2Errors.filter((name: { path: string; }) => name.path === "saveing")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="ریال" iconBorder icon={<SquareTransferVertical />} myStyle="inquery-input w-48" lable="  آورده اولیه" value={saveing} onChange={(e: any) => this.setState({ saveing: e })} />
                                                {/* </div>
                                                <div className="row-container "> */}
                                                    <Dropdown hideWhenDisabled hasNotice="جهت خنثی کردن اثر تورمی موجود در کشور می‌توانید سالانه حق‌بیمه خود را به نسبت سال قبل حداکثر تا 50 درصد افزایش دهید." disabled={payment_method === 0 ? true : false} items={limitationInquiry?.filter((item: { name: string; }) => item.name === "adjustment_coefficient_permium")[0]?.values} error={step2Errors.filter((name: { path: string; }) => name.path === "adjustment_coefficient_permium")?.[0]?.errors?.[0]} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-48" lable="افزایش سالانه حق بیمه  (درصد) " placeholder="  انتخاب کنید " value={adjustment_coefficient_permium} onChange={(e: any) => this.setState({ adjustment_coefficient_permium: e.target.value })} icon={<img src={ChatSquare} alt="هامرز" />} />
                                                    <Dropdown hideWhenDisabled hasNotice="درصورت تمایل می‌توانید حق‌بیمه‌ی پوشش‌های بیمه‌ای را جداگانه و مستقل از بخش سرمایه‌گذاری پرداخت نمایید." disabled={payment_method !== 0 ? true : false} objectList items={[{ title: "بله", value: true }, { title: "خیر", value: false }]} error={step2Errors.filter((name: { path: string; }) => name.path === "decuple_coverages_premium")?.[0]?.errors?.[0]} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-48" lable="پرداخت جداگانه‌ی حق بیمه پوشش‌های بیمه‌ای" placeholder="  انتخاب کنید " value={decuple_coverages_premium} onChange={(e: any) => this.setState({ decuple_coverages_premium: e.target.value })} icon={<img src={ChatSquare} alt="هامرز" />} />
                                                {/* </div>
                                                <div className="row-container "> */}
                                                    <Input hideWhenDisabled  hasNotice="مدت بیمه‌نامه برابر حداقل 5 سال و حداکثر 30 سال بوده، به‌طوری‌که مدت بیمه‌نامه به اضافه‌ی سن فعلی بیمه‌شده می‌بایست کمتر از 80 سال باشد." error={step2Errors.filter((name: { path: string; }) => name.path === "duration")?.[0]?.errors?.[0]} hideEndAdornment endAdornment="سال" isRequired type="number" iconBorder icon={<img src={History} alt="هامرز" />} myStyle="inquery-input w-48" lable=" مدت بیمه" value={duration} onChange={(e: any) => this.setState({ duration: e })} />
                                                    <Input hideWhenDisabled hasNotice="مدت زمانی است که بیمه‌گذار براساس شرایط اقتصادی خود برای پرداخت حق‌بیمه انتخاب می‌کند. مدت پرداخت حق‌بیمه می‌بایست کمتر یا مساوی با مدت بیمه باشد." disabled={payment_method === 0 ? true : false} error={step2Errors.filter((name: { path: string; }) => name.path === "payment_duration")?.[0]?.errors?.[0]} hideEndAdornment endAdornment="سال" isRequired type="number" iconBorder icon={<CardTransfer color="#000000" />} myStyle="inquery-input w-48" lable="مدت پرداخت حق بیمه" value={payment_duration} onChange={(e: any) => this.setState({ payment_duration: e })} />
                                                </div>
                                            {/* </div> */}
                                        </>
                                    }
                                    {step === 3 &&
                                        <div className="inquery-form">
                                            <div className="cover mb-3">
                                                <span className="cover-title">
                                                    پوشش اصلی
                                                </span>
                                            </div>
                                            <div className="row-container">
                                                <Input hasNotice={`سرمایه فوت مبلغی است که اگر بیمه‌شده فوت کند، به فرد یا افرادی که برای دریافت این مبلغ تعیین شده‌اند، پرداخت می‌شود. حداکثر مبلغ سرمایه فوت 50 میلیارد ریال است. 
                                                    ${payment_method === 0 ? "اگر حق‌بیمه را یکجا پرداخت کنید، مبلغ سرمایه فوت حداکثر 10 برابر حق‌بیمه پرداخت‌شده خواهد بود." : " اگر حق‌بیمه را در طول سال به‌صورت قسطی پرداخت می‌کنید، مبلغ سرمایه فوت می‌تواند بین 1 تا 35 برابر مجموع حق‌بیمه‌های یک سال باشد. "}
                                                    `} hasComma error={step3Errors.filter((name: { path: string; }) => name.path === "start_death_asset")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="ریال" iconBorder icon={<SquareTransferVertical />} myStyle="inquery-input w-30"
                                                 lable={payment_method === 0 ? "سرمایه فوت به هر علت " : "سرمایه فوت به هر علت (سال اول )"} value={start_death_asset} onChange={(e: any) => this.setState({ start_death_asset: e })} />
                                                <Dropdown hasNotice="شما می‌توانید با انتخاب هر یک از درصدهای زیر که می‌بایست کمتر یا مساوی درصد افزایش سالانه حق‌بیمه انتخابی باشد، میزان سرمایه فوت خود را به صورت سالانه افزایش دهید." items={limitationInquiry?.filter((item: { name: string; }) => item.name === "adjustment_coefficient_death_benefit")[0]?.values} error={step3Errors.filter((name: { path: string; }) => name.path === "adjustment_coefficient_death_benefit")?.[0]?.errors?.[0]} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-30" lable="افزایش سالانه سرمایه فوت (درصد) " placeholder="  انتخاب کنید " value={adjustment_coefficient_death_benefit} onChange={(e: any) => this.setState({ adjustment_coefficient_death_benefit: e.target.value })} icon={<img src={GraphNewUp} alt="هامرز" />} />
                                                <Dropdown contentLoading={contentLoading} objectList error={step3Errors.filter((name: { path: string; }) => name.path === "insurred_extra_dangers")?.[0]?.errors?.[0]} items={extrarisk} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-30" lable="خطرات اضافه   " placeholder="  انتخاب کنید " value={this.state.insurred_extra_dangers}
                                                    onChange={(event: any) => this.changeDangerInsured(event.target.value)} icon={<Money />} />
                                            </div>

                                            <div className="cover mb-2">
                                                <span className="cover-title">
                                                    پوشش های تکمیلی حادثه
                                                </span>
                                                <span className="cover-title cover-subtitle">
                                                    قابل خریداری ( اختیاری)
                                                </span>
                                            </div>
                                            <div className="row-container">
                                                <CustomSelect onChange={(e: any) => this.changeAccidentDeathCoverage(e)}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "accident_death_coverage")[0]}
                                                    value={accident_death_coverage} placeholder="غرامت فوت ناشی از حادثه (برابر) " myStyle="w-30" 
                                                    hasNotice="سرمایه‌ای است که هرگاه بیمه‌شده به علت حادثه فوت شود به استفاده‌کننده (گان) به شرط فوت، پرداخت می‌شود. حداقل نسبت این سرمایه (سرمایه فوت در اثر حادثه) به سرمایه فوت به هر علت، 1 و حداکثر 4 برابر است. " />


                                                <CustomSelect onChange={(e: any) => this.setState({ accident_medical_cost_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "accident_medical_cost_coverage")[0]}
                                                    value={accident_medical_cost_coverage} placeholder=" هزینه پزشکی (درصد) " myStyle="w-30"
                                                    disabled={accident_death_coverage === "0" || accident_death_coverage === "" || Number(accident_death_coverage) === 0}
                                                    hasNotice="حداکثر معادل 20 درصد از سرمایه فوت به هرعلت که در صورت نیاز بیمه‌شده به خدمات درمانی ناشی از حوادث، به وی تعلق می‌گیرد. "
                                                />

                                                <CustomSelect onChange={(e: any) => this.setState({ temporary_and_permanent_disability_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "temporary_and_permanent_disability_coverage")[0]}
                                                    disabled={accident_death_coverage === "0" || accident_death_coverage === "" || Number(accident_death_coverage) === 0}
                                                    value={temporary_and_permanent_disability_coverage} placeholder=" نقص عضو دائم  کلی و جزیی (درصد)  " myStyle="w-30" 
                                                    hasNotice="حداکثر معادل 100 درصد از سرمایه فوت به هرعلت که در صورت نقص عضو بیمه‌شده به وی تعلق می‌گیرد. " />

                                            </div>

                                            <div className="row-container">
                                                <CustomSelect onChange={(e: any) => this.setState({ has_temporary_disability_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_temporary_disability_coverage")[0]}
                                                    value={has_temporary_disability_coverage} placeholder=" غرامت روزانه عمومی" myStyle="w-30"
                                                    hasNotice="روزانه معادل پنج در هزار سرمایه فوت به هر علت، در دوران ازکارافتادگی موقت بیمه‌شده که بر اثر حادثه ایجاد شده باشد، به وی پرداخت می‌شود"
                                                    disabled={accident_death_coverage === "0" || accident_death_coverage === "" || Number(accident_death_coverage) === 0} />
                                                <CustomSelect onChange={(e: any) => this.setState({ has_hos_benefit_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_hos_benefit_coverage")[0]}
                                                    value={has_hos_benefit_coverage} placeholder="غرامت روزانه بستری" myStyle="w-30"
                                                    hasNotice="روزانه معادل پنج در هزار سرمایه فوت به هر علت، در دوران بستری بيمه شده در مراكز درمانی که بر اثر حادثه ایجاد شده باشد، به وی پرداخت می‌شود. "
                                                    disabled={accident_death_coverage === "0" || accident_death_coverage === "" || Number(accident_death_coverage) === 0} />



                                                <CustomSelect contentLoading={contentLoading} onChange={(e: any) => this.setState({ annuity_disability_coverage_accident: e })}
                                                hasNotice="حداکثر معادل 10 درصد از سرمایه فوت به هر علت که درصورت نقص عضو و ازکارافتادگی دائم کلی بیمه‌شده که بر اثر حادثه ایجاد شده باشد، توسط شرکت بیمه در زمان حیات وی و حداکثر تا پایان مدت بیمه‌نامه به‌صورت مستمری به وی پرداخت خواهد نمود."
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "annuity_disability_coverage_accident")[0]} value={annuity_disability_coverage_accident} placeholder=" پرداخت مستمری ازکارافتادگی دائم (درصد) " myStyle="w-30 " />


                                            </div>


                                            <div className="cover mb-2">
                                                <span className="cover-title">
                                                    پوشش های تکمیلی درمان
                                                </span>
                                                <span className="cover-title cover-subtitle">
                                                    قابل خریداری ( اختیاری)
                                                </span>
                                            </div>
                                            <div className="row-container">

                                                <CustomSelect onChange={(e: any) => this.handleChangeCancer(e)}
                                                hasNotice="حداکثر معادل 50 درصد از سرمایه فوت به هر علت که درصورت ابتلای بیمه‌شده به سرطان، به وی پرداخت خواهد شد."
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "cancer_coverage")[0]}
                                                    value={cancer_coverage} placeholder="بیماری سرطان (درصد) " myStyle="w-48" />


                                                <CustomSelect

                                                    disabled={cancer_coverage === "0" || cancer_coverage === "" || cancer_coverage === 0}
                                                    onChange={(e: any) => this.setState({ has_cancer_diagnosis: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_cancer_diagnosis")[0]}
                                                    value={has_cancer_diagnosis} placeholder="هزینه تشخیص سرطان" myStyle="w-48" 
                                                    hasNotice="معادل 20 درصد از غرامت بیماری سرطان است که جبران هزینه های ناشی از تشخیص سرطان بیمه‌شده، به وی پرداخت می‌گردد. "/>



                                            </div>
                                            <div className="row-container">
                                                <CustomSelect onChange={(e: any) => this.setState({ main_special_diseases_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "main_special_diseases_coverage")[0]}
                                                    value={main_special_diseases_coverage} placeholder=" امراض خاص اصلی (درصد) " myStyle="w-30"
                                                    hasNotice="حداکثر معادل 50 درصد از سرمایه فوت به هر علت است و بیماری‌های مشمول این پوشش عبارت است از مجموعه اعمال تهاجمی قلب، سکته قلبی، سکته مغزی و پیوند اعضای اصلی بدن شامل: قلب، ریه، کبد، کلیه، مغز و استخوان. " />
                                                <CustomSelect onChange={(e: any) => this.setState({ has_supplementary_special_diseases_coverage: e })}
                                                    disabled={main_special_diseases_coverage === "0" || main_special_diseases_coverage === "" || main_special_diseases_coverage === 0}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_supplementary_special_diseases_coverage")[0]}
                                                    value={has_supplementary_special_diseases_coverage} placeholder=" امراض خاص تکمیلی" myStyle="w-30" 
                                                    hasNotice="حداکثر معادل غرامت امراض خاص اصلی است" />


                                                <CustomSelect contentLoading={contentLoading} onChange={(e: any) => this.setState({ annuity_disability_coverage_disease: e })}
                                                hasNotice="حداکثر معادل 10 درصد از سرمایه فوت به هر علت که درصورت نقص عضو و ازکارافتادگی دائم کلی بیمه‌شده که بر اثر بیماری ایجاد شده باشد، توسط بیمه‌گر در زمان حیات وی و حداکثر تا پایان مدت بیمه‌نامه به‌صورت مستمری به وی پرداخت خواهد نمود."
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "annuity_disability_coverage_disease")[0]} value={annuity_disability_coverage_disease} placeholder=" پرداخت مستمری ازکارافتادگی دائم (درصد) " myStyle="w-30" />



                                            </div>


                                        </div>


                                    }
                                    {step === 4 &&
                                        <div className="inquery-form">



                                            <div className="cover mb-2">
                                                {contentLoading ?
                                                    <div className="content-loading mt-2"></div>
                                                    :
                                                    <span className="cover-title">
                                                        پوشش های بیمه گذار
                                                    </span>
                                                }
                                            </div>
                                            <div className="row-container flex-column align-items-center">
                                                <Dropdown disabled={payment_method === 0 || this.state.selfsame ? true : false} contentLoading={contentLoading} objectList error={step4Errors.filter((name: { path: string; }) => name.path === "policy_holder_extra_dangers")?.[0]?.errors?.[0]} items={extrarisk} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-48" lable=" خطرات اضافه  " placeholder="  انتخاب کنید " value={this.state.policy_holder_extra_dangers}
                                                    onChange={(event: any) => this.changeDangerHolder(event.target.value)} icon={<Money />} />
                                                <CustomSelect hasNotice="درصورتی که بیمه‌گذار به دلیل بیماری‌های مشمول این بیمه‌نامه دچار نقص عضو و از کارافتادگی دائم و کامل گردد، از پرداخت حق‌بیمه معاف و شرکت بیمه زندگی هامرز به جای وی اقساط حق‌بیمه را تا پایان مدت بیمه‌نامه یا سن موثر 80 سالگی (هرکدام زودتر بود) پرداخت خواهد کرد. " disabled={payment_method === 0 ? true : false} onChange={(e: any) => this.setState({ has_waiver_diseases_policy_holder: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_waiver_diseases_policy_holder")[0]}
                                                    value={has_waiver_diseases_policy_holder} placeholder="معافیت از پرداخت حق بیمه در اثر بیماری" myStyle="w-48 mb-2" />
                                                <CustomSelect disabled={payment_method === 0 ? true : false} onChange={(e: any) => this.setState({ has_waiver_accident_policy_holder: e })}
                                                                                        hasNotice="درصورتی که بیمه‌گذار به دلیل خطرات مشمول این بیمه‌نامه دچار نقص عضو و از کارافتادگی دائم و کامل گردد، از پرداخت حق‌بیمه معاف و شرکت بیمه زندگی هامرز به جای وی اقساط حق‌بیمه را تا پایان مدت بیمه‌نامه یا سن موثر 80 سالگی (هرکدام زودتر بود) پرداخت خواهد کرد. "
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_waiver_accident_policy_holder")[0]} value={has_waiver_accident_policy_holder} placeholder=" معافیت از پرداخت حق بیمه در اثر حادثه" myStyle="w-48" />
                                            </div>
                                        </div>

                                    }

                                    {step === 5 &&
                                        <>

                                            <div className="inquery-form">
                                                <div className="cover mb-2">

                                                    {contentLoading ?
                                                        <div className="content-loading mt-2"></div>
                                                        :
                                                        <>
                                                                                                                <div className="cover-title mb-2">
                                                                                                                شما می‌توانید یک، دو یا سه صندوق سرمایه‌گذاری انتخاب کنید، به شرطی که مجموع درصدهای انتخابی شما برابر با 100 درصد باشد.                                                        </div>
                                                        {/* <div className="cover-title">
                                                            اطلاعات صندوق های سرمایه گذاری
                                                        </div> */}

                                                        </>
                                                    }
                                                </div>
                                                <div className="row-container">
                                                    <div className="issuing-table">
                                                        <table className="table hide-mobile">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">ردیف</th>

                                                                    <th scope="col"> صندوق  </th>
                                                                    <th scope="col">درصد سهم</th>
                                                                    <th scope="col"> عملیات </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {life_bens && life_bens.length > 0 && life_bens?.map((item: any, index: number) => (
                                                                    <tr key={index}>
                                                                        <th>{index + 1}</th>
                                                                        <th>{relationPersonList?.find((element: { value: any; }) => element?.value === item?.project_id)?.title || "---"}</th>

                                                                        <th>{item?.percent || "---"}%</th>
                                                                        <th>
                                                                            <span className="remove" onClick={() => this.removeLifeObj(index, item?.priority)}>حذف</span></th>
                                                                    </tr>
                                                                )
                                                                )}
                                                            </tbody>
                                                            <tfoot>

                                                                <tr ><td className="add-fund-btn" colSpan={8} onClick={() => this.handleOpenModal()}>
                                                                    <img src={Add} alt="هامرز" />
                                                                    <span >
                                                                        افزودن صندوق
                                                                    </span>                                                        </td></tr>
                                                            </tfoot>

                                                        </table>

                                                    </div>
                                                </div>
                                                {step5Errors.filter((name: { path: string; }) => name.path === "life_bens")?.[0]?.errors?.[0] &&

                                                    <label className="custom-input-error">
                                                        {step5Errors.filter((name: { path: string; }) => name.path === "life_bens")?.[0]?.errors?.[0]}
                                                    </label>

                                                }
                                            </div>
                                        </>
                                    }
                                    {step !== 6 &&

                                        <div className="inquery-btn-group">
                                            {contentLoading ? <>
                                                <div className="content-loading"></div>
                                                {/* <div className="content-loading"></div> */}
                                            </> :



                                                <>

                                                    <Button myStyle="bg-blue next-btn" title="مرحله بعد" onClick={() => this.increaseSteper(true)} />
                                            {step !== 1 &&
                                                    <Button myStyle="bg-outline-white pre-btn" title="مرحله قبل" onClick={() => this.decreaseSteper()} />

                                            }
                                                </>

                                            }
                                        </div>


                                    }
                                </>
                            </div>
                        }
                    </div>
                </div>
                {/* ///////////// */}
                <div className=" inquery hide-desktop ">
                    {step === 6 ?
                        <>

                            <div className="inquery-tab">


                                <div className={`${this.state.tab === 1 ? "inquery-tab-item-active" : ""} inquery-tab-item`}>

                                    <div className={`${this.state.tab === 1 ? "tab-active" : "tab-deactive"} tab-style`} onClick={() => this.setState({ tab: 1 })}>
                                        جدول پرداخت حق بیمه
                                    </div>
                                    {this.state.tab === 1 &&
                                        <span className="up-arrow"></span>
                                    }
                                </div>

                                <div className={`${this.state.tab === 0 ? "inquery-tab-item-active" : ""} inquery-tab-item`}>
                                    <div className={`${this.state.tab === 0 ? "tab-active" : "tab-deactive"} tab-style`} onClick={() => this.setState({ tab: 0 })}>
                                        استعلام حق بیمه

                                    </div>
                                    {this.state.tab === 0 &&
                                        <span className="up-arrow"></span>
                                    }
                                </div>


                            </div>

                            <div className="inquery-result-container scrollbar">

                                {this.state.tab === 0 ?


                                    <div className="inquery-result">
                                        <div className="inquery-result-data">
                                            <div className={`${showInfo ? "data-accordion-expand" : "data-accordion"} data-items `}>

                                                <div className="data-item">
                                                    <span className="title ">
                                                        مدت بیمه نامه
                                                    </span>
                                                    <span className="description">
                                                        {duration} سال
                                                    </span>
                                                </div>
                                                <div className="data-item">
                                                    <span className="title ">
                                                        نحوه پرداخت حق بیمه
                                                    </span>
                                                    <span className="description">
                                                        {paymentMethodList.find((x: { value: any; }) => x.value === payment_method)?.title}
                                                    </span>
                                                </div>
                                                {payment_method !== 0 &&

                                                    <div className="data-item">
                                                        <span className="title ">
                                                            مدت پرداخت حق بیمه
                                                        </span>
                                                        <span className="description">
                                                            {payment_duration} سال
                                                        </span>
                                                    </div>
                                                }

                                                {payment_method !== 0 &&

                                                    <div className="data-item">
                                                        <span className="title ">
                                                            مبلغ آورده اولیه
                                                        </span>
                                                        <span className="description">
                                                            {numberWithCommas(saveing)} ریال
                                                        </span>

                                                    </div>
                                                }
                                                {payment_method !== 0 &&

                                                    <div className="data-item">
                                                        <span className="title">
                                                        افزایش سالانه حق بیمه 
                                                        </span>
                                                        <span className="description">
                                                            {adjustment_coefficient_permium} درصد
                                                        </span>

                                                    </div>
                                                }
                                                <div className="data-item">
                                                    <span className="title">
                                                        افزایش سالانه سرمایه فوت
                                                    </span>
                                                    <span className="description">
                                                        {adjustment_coefficient_death_benefit} درصد
                                                    </span>

                                                </div>


                                                <div className="data-item">
                                                    <span className="title">
                                                        پوشش فوت   حادثه
                                                    </span>
                                                    <span className="description">
                                                        {accident_death_coverage} برابر
                                                    </span>

                                                </div>





                                                <div className="data-item">
                                                    <span className="title">
                                                        پوشش نقص عضو
                                                    </span>
                                                    <span className="description">
                                                        {temporary_and_permanent_disability_coverage} درصد
                                                    </span>

                                                </div>
                                                <div className="data-item">
                                                    <span className="title">
                                                       غرامت روزانه بستری
                                                    </span>
                                                    <span className="description">
                                                        {has_hos_benefit_coverage ? "بله" : "خیر"}
                                                    </span>

                                                </div> <div className="data-item">
                                                    <span className="title">
                                                        غرامت روزانه عمومی                                                </span>
                                                    <span className="description">
                                                        {has_temporary_disability_coverage ? "بله" : "خیر"}
                                                    </span>

                                                </div> <div className="data-item">
                                                    <span className="title">
                                                    پرداخت مستمری ازکارافتادگی دائم                                                     </span>
                                                    <span className="description">
                                                        حادثه {annuity_disability_coverage_accident} درصد | بیماری {annuity_disability_coverage_disease} درصد
                                                    </span>

                                                </div> <div className="data-item">
                                                    <span className="title">
                                                        پوشش امراض خاص
                                                    </span>
                                                    <span className="description">
                                                        اصلی: {main_special_diseases_coverage} درصد  | تکمیلی: {has_supplementary_special_diseases_coverage ? "بله" : "خیر"}
                                                    </span>

                                                </div>
                                                {payment_method !== 0 &&

                                                    <div className="data-item">
                                                        <span className="title">
                                                            پوشش معافیت از پرداخت حق بیمه
                                                        </span>
                                                        <span className="description">
                                                            حادثه: {has_waiver_accident_policy_holder ? "بله" : "خیر"} | بیماری : {has_waiver_diseases_policy_holder ? "بله" : "خیر"}
                                                        </span>

                                                    </div>
                                                }
                                                <div className="data-item">
                                                    <span className="title">
                                                       بیماری سرطان
                                                    </span>
                                                    <span className="description">
                                                        {cancer_coverage} درصد
                                                    </span>

                                                </div>
                                                <div className="data-item">
                                                    <span className="title">
                                                        هزینه تشخیص سرطان </span>
                                                    <span className="description">
                                                        {has_cancer_diagnosis ? "بله" : "خیر"}
                                                    </span>

                                                </div>
                                                {payment_method === 0 &&
                                                    <>

                                                        <div className="data-item">
                                                            <span className="title">
                                                        پرداخت جداگانه‌ی حق بیمه پوشش‌های بیمه‌ای
                                                            </span>
                                                            <span className="description">
                                                                {decuple_coverages_premium ? "بله" : "خیر"}
                                                            </span>
                                                        </div>
                                                        <div className="data-item"></div>
                                                    </>
                                                }
                                                <div className="data-item"></div>


                                            </div>
                                            <div className="d-flex justify-content-center">
                                                <div className="data-arrow" onClick={() => this.setState({ showInfo: !this.state.showInfo })}>
                                                    <img className={showInfo ? "rotate-180" : ""} src={Arrowdown2} alt="هامرز" />
                                                </div>
                                            </div>
                                        </div>


                                        {/* <div className="inquery-result-chart"> */}
                                        <div className="info-chart mt-2">
                                            <div className="info-chart-headline">
                                        <div className="info-chart-headline-download">
                                                <span className="title">
                                                    رشد اندوخته
                                                </span>
                                                <Button loading={base64Loading} icon={Import} myStyle="replay bg-blue next-btn loading-spinner-primary " title="چاپ جدول تعهدات" onClick={()=>this.downloadPdf()} />
                                                </div>
                                                <div className="d-flex">
                                                    <div className="roshd">
                                                        <span className="roshd-badge t"></span>
                                                        <span className="roshd-title">  رشد تضمینی  (ریال)</span>

                                                    </div>
                                                    <div className="roshd me-3">
                                                        <span className="roshd-badge p"></span>
                                                        <span className="roshd-title"> رشد پیش بینی شده (ریال)</span>

                                                    </div>
                                                </div>
                                            </div>
                                            <Line
                                                data={this.state.data}
                                                options={this.state.options}

                                            />
                                        </div>
                                    </div>


                                    :

                                    <div className="policy w-100 table-responsive mt-2">
                                        <div>

                                            {result?.result?.slice(currentPage * 5, currentPage * 5 + 5)?.map((item: any, index: number) => {
                                                return (
                                                    <Accordion className="policy-accordion hide-desktop">
                                                        <AccordionSummary
                                                            expandIcon={<img src={Arrowdown2} alt="هامرز" />}
                                                            aria-controls="panel1a-content"
                                                            className="summsry"
                                                            id="panel1a-header"
                                                        >

                                                            <TableRowResponsive title="سال" value={item?.term_year} />
                                                            <TableRowResponsive title="سن" value={item?.age} />
                                                            <TableRowResponsive title={payment_method === 0 ? "حق بیمه  یکجا" : "حق بیمه سالیانه "} value={numberWithCommas(item?.pre_annually)} />
                                                        </AccordionSummary>
                                                        <AccordionDetails
                                                            className="d-flex flex-wrap"
                                                        >
                                                            <TableRowResponsive title=" سرمایه فوت" value={numberWithCommas(item?.death_benefit)} />
                                                            <TableRowResponsive title="سرمایه فوت حادثه  " value={numberWithCommas(item?.acc_death_benefit)} />
                                                            <TableRowResponsive title=" سرمایه نقص عضو" value={numberWithCommas(item?.acc_dis_benefit)} />


                                                        </AccordionDetails>
                                                        <AccordionDetails
                                                            className="d-flex flex-wrap"
                                                        >
                                                            <TableRowResponsive title=" سرمایه هزینه پزشکی" value={numberWithCommas(item?.acc_med_exp_benefit)} />
                                                            <TableRowResponsive title="بیماری خاص اصلی" value={numberWithCommas(item?.critical_main_benefit)} />
                                                            <TableRowResponsive title=" سرمایه بیماری سرطان" value={numberWithCommas(item?.cancer_benefit)} />
                                                        </AccordionDetails>
                                                        <AccordionDetails
                                                            className="d-flex flex-wrap"
                                                        >
                                                            <TableRowResponsive title="بازخریدی (تضمینی) " value={numberWithCommas(item?.guaranteed_reserve)} />
                                                            <TableRowResponsive title="بازخریدی (پیشبینی) " value={numberWithCommas(item?.forecast_redeem_value)} />
                                                        </AccordionDetails>
                                                    </Accordion>
                                                )
                                            })}
                                        </div>

                                        <Pagination
                                            className="custom-pagination mt-3"
                                            count={result?.result ? Math.ceil(result?.result?.length / 5) : 1}
                                            onChange={this.handleChangePage}
                                            size="small"
                                            page={currentPage + 1}
                                            renderItem={(item) => (
                                                <PaginationItem
                                                    slots={{ previous: Forward, next: ArrowBack }}
                                                    {...item}
                                                />
                                            )}
                                        />
                                    </div>


                                }
                            </div>
                            <div className="Inquery-result-btn-group inquery-btn-group">
                            {result?.universal_offer ?
                                        <Button icon={ReplyPic} myStyle="replay bg-green next-btn" title="ثبت پیشنهاد بیمه نامه"  link={window.location.pathname.split("/")[2] ? `${routes?.UNITLINKISSUING}/${window.location.pathname.split("/")[2]}` : routes.UNITLINKISSUING} />


                                        :
                                        <Button icon={ReplyPic} myStyle="replay bg-green next-btn" title="ثبت پیشنهاد بیمه نامه" onClick={() => toast.error("با توجه به منفی شدن ارزش بازخرید , خواهشمند است نسبت به افزایش حق بیمه یا کاهش تعهدات اقدام فرمایید . ")} />


                                    }
                                <div className="user-dashboard" onClick={() => this.setState({ showUpdateMOdal: !showUpdateMOdal })} >

                                    ویرایش بیمه نامه
                                </div>
                            </div>


                            <Dialog


                                className="update-dialog-container"
                                TransitionComponent={Transition}

                                open={showUpdateMOdal} onClose={() => this.setState({ showUpdateMOdal: !showUpdateMOdal })}
                                aria-labelledby="update-dialog">

                                <div className="update-dialog">
                                    <div className="update-dialog-headline"><span className="rectangle"></span></div>
                                    <div className="update-dialog-title">
                                        جهت ویرایش هر یک از بخش های بیمه های بیمه نامه میتوانید روی بخش مربوطه کلیک کنید
                                    </div>
                                    <StepperItemMobileUpdate onClick={() => this.setState({ step: 1, handleMobileStep1: false, showUpdateMOdal: false })} hasBorder stepTitle="مرحله اول" stepSubTitle="اطلاعات هویتی  " stepDesc="اطلاعات پایه هویتی  " />
                                    <StepperItemMobileUpdate onClick={() => this.setState({ step: 2, showUpdateMOdal: false })} hasBorder stepTitle="مرحله دوم" stepSubTitle="اطلاعات  بیمه نامه" stepDesc="آورده اولیه ، حق بیمه ، ضریب تعدیل و مدت پرداخت" />
                                    <StepperItemMobileUpdate onClick={() => this.setState({ step: 3, showUpdateMOdal: false })} stepTitle="مرحله سوم" stepSubTitle="پوشش های بیمه ای" stepDesc="پوشش های بیمه شده و بیمه گذار و پوشش های تکمیلی" />


                                </div>

                            </Dialog>
                        </>
                        :
                        <>

                            {contentLoading ? <div className="stepper-loading w-100">
                                <div className="content-loading "></div>
                                <div className="content-loading mt-2"></div>
                            </div>

                                :
                                <>

                                    <div className="inquery-title">

                                        {(step === 1 && !this.state.handleMobileStep1) && "اطلاعات هویتی بیمه گذار"}
                                        {(step === 1 && this.state.handleMobileStep1) && "اطلاعات هویتی بیمه شده"}
                                        {step === 2 && "اطلاعات بیمه"}
                                        {step === 3 && "پوشش های بیمه ای"}
                                        {step === 4 && "پوشش های بیمه گذار"}
                                        {step === 5 && " صندوق ها"}



                                    </div>
                                    <div className="stepper-container-mobile">
                                        <StepperItemMobile step={5} activeStep={step} />
                                        <StepperItemMobile step={3} activeStep={step} >
                                            <div className="mobile-step-in">
                                                <div className={`${step > 3 ? "mobile-step-active" : "mobile-step-deactive"} item`}></div>
                                                <div className={`${step === 3 || step > 3 ? "mobile-step-active" : "mobile-step-deactive"} item`}></div>
                                            </div>
                                        </StepperItemMobile>
                                        <StepperItemMobile step={2} activeStep={step} />
                                        <StepperItemMobile step={1} activeStep={step} />
                                    </div>
                                </>
                            }
                            <br />
                            <div className="inquery-container">


                                {step === 1 && this.state.handleMobileStep1 === false &&
                                    <>
                                        <div className="inquery-form scrollbar ">
                                            <div className="row-container ">

                                            <Input  hasNotice="درصورت داشتن شماره قرارداد آن را وارد نمایید، درغیر این صورت چیزی ننویسید." disabled={window.location.pathname.split("/")[2] ? true : false} contentLoading={contentLoading} lable="شماره قرارداد" error={step1Errors.filter((name: { path: string; }) => name.path === "contract_id")?.[0]?.errors?.[0]} hideEndAdornment type="number" endAdornment="" max="10" myStyle="inquery-input w-100"  value={contract_id} onChange={(e: any) => this.setState({ contract_id: e })} />

                                          </div>
                                            <div className="w-100 mb-4">
                                                <DatePickerInput
                                                    iconBorder
                                                    ref={this.datePickerRefHolder}
                                                    disabled
                                                    contentLoading={contentLoading}
                                                    error={step1Errors.filter((name: { path: string; }) => name.path === "holder_birthday")?.[0]?.errors?.[0]}
                                                    // emptyState={() => this.setState({ holder_birthday: "" })}
                                                    value={this.state.holder_birthday}
                                                    onChange={this.handleChangeHolderBD}
                                                    isRequired hideEndAdornment
                                                    calendarPosition="bottom-right"
                                                    containerClassName="date-picker-container w-100"
                                                    inputClass="date-picker-input"
                                                    myStyle="inquery-input mb-0"
                                                    lable="تاریخ تولد"
                                                    icon={<img src={Calendar3} alt="هامرز" />}
                                                    maxDate={new DateObject({ calendar: persian }).subtract(18, "years")}

                                                />

                                            </div>

                                            <CustomSearch  hasNotice="درصورت داشتن چندین شغل خواهشمند است شغلی که عمده درآمد خود را از آن کسب می‌کنید، انتخاب نمایید." contentLoading={contentLoading} loading={jobListHolderLoading} error={step1Errors.filter((name: { path: string; }) => name.path === "policy_holder_job_category")?.[0]?.errors?.[0]} iconBorder icon={<img src={User} alt="هامرز" />} lable="شغل  " isRequired search={(e: any) => this.getJobHolder(e)} value={this.state.policy_holder_job_category} title={this.state.policy_holder_job_category_title} item={jobListHolder} myStyle="w-100 mb-4" placeholder="انتخاب کنید" onChange={(event: any) => this.changeJobHolder(event)} />

                                            <div className="title-check-container">
                                                {contentLoading ? <div className="content-loading content-loading-lable mt-2"></div> :
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox checked={this.state.selfsame} onChange={(e: any) => this.selfsame(e)} name="selfsame" sx={{
                                                                // color: "#155a9e",
                                                                borderRadius: "3px",
                                                                width: "23px",
                                                                height: "23px",
                                                                '&.Mui-checked': {
                                                                    // color: "#155a9e",
                                                                    borderRadius: "3px",
                                                                    width: "23px",
                                                                    height: "23px",
                                                                },
                                                                '&.MuiCheckbox-root': {
                                                                    padding: 0
                                                                }
                                                            }} />
                                                        }
                                                        label="بیمه گذار و بیمه شده یک شخص واحد می باشد."
                                                    />

                                                }
                                            </div>
                                        </div>
                                        {/* // */}
                                        {this.state.isEdited ?
                                            <div className="inquery-result-btn-group inquery-btn-group">
                                                <Button icon={Tick} myStyle="replay bg-green next-btn" title="اعمال تغییرات" onClick={() => this.checkStepMobile1(false)} />
                                                <div className="user-dashboard" onClick={() => this.checkStepMobile1(true)}>

                                                    ادامه ویرایش
                                                </div>
                                            </div>

                                            :
                                            <>

                                                <div className="inquery-btn-group">
                                                    {contentLoading ? <>
                                                        <div className="content-loading"></div>
                                                        {/* <div className="content-loading"></div> */}
                                                    </> :
                                                        <>
                                                            <Button myStyle="bg-blue next-btn" title="مرحله بعد" onClick={() => this.checkStepMobile1(true)} />
                                            {step !== 1 &&

                                                            <Button myStyle="bg-outline-white pre-btn" title="مرحله قبل" onClick={() => this.decreaseSteper()} />
                                            }
                                                        </>
                                                    }
                                                </div>

                                            </>

                                        }

                                        {/* // */}


                                    </>
                                }

                                {step === 1 && this.state.handleMobileStep1 &&

                                    <>
                                        {/* {havig()} */}
                                        <div className="inquery-form scrollbar">

                                            <div className="w-100 mb-4">
                                                <DatePickerInput
                                                    iconBorder
                                                    ref={this.datePickerRefInsured}

                                                    contentLoading={contentLoading}
                                                    emptyState={() => this.setState({ insured_birthday: "" })}
                                                    error={step1Errors.filter((name: { path: string; }) => name.path === "insured_birthday")?.[0]?.errors?.[0]}
                                                    value={this.state.insured_birthday}
                                                    isRequired hideEndAdornment
                                                    myStyle="inquery-input mb-0"
                                                    lable="تاریخ تولد"
                                                    calendarPosition="bottom-right"
                                                    containerClassName="date-picker-container w-100"
                                                    inputClass="date-picker-input"
                                                    icon={<img src={Calendar3} alt="هامرز" />}
                                                    onChange={this.handleChangeInsuredBD}
                                                    maxDate={new DateObject({
                                                        calendar: persian,
                                                    })}
                                                />

                                            </div>
                                            <CustomSearch  hasNotice="درصورت داشتن چندین شغل خواهشمند است شغلی که عمده درآمد خود را از آن کسب می‌کنید، انتخاب نمایید." contentLoading={contentLoading} loading={jobListInquiryLoading} error={step1Errors.filter((name: { path: string; }) => name.path === "insured_job_category")?.[0]?.errors?.[0]} iconBorder icon={<img src={User} alt="هامرز" />} lable="شغل  " isRequired search={(e: any) => this.getJobInquiry(e)} value={this.state.insured_job_category} title={this.state.insured_job_category_title} item={jobListInquiry} myStyle="w-100 mb-4" placeholder="انتخاب کنید" onChange={(event: any) => this.changeJobInsured(event)} />


                                        </div>

                                        {this.state.isEdited ?
                                            <div className="inquery-result-btn-group inquery-btn-group">
                                                <Button icon={Tick} myStyle="replay bg-green next-btn" title="اعمال تغییرات" onClick={() => this.checkStepMobile2(false)} />
                                                <div className="user-dashboard" onClick={() => this.checkStepMobile2(true)}>

                                                    ادامه ویرایش
                                                </div>
                                            </div>

                                            :
                                            <div className="inquery-btn-group">
                                                <Button myStyle="bg-blue next-btn" title="مرحله بعد" onClick={() => this.checkStepMobile2(true)} />
                                                <Button myStyle="bg-outline-white pre-btn" title="مرحله قبل" onClick={() => this.decreaseSteper2()} />
                                            </div>


                                        }
                                    </>
                                }

                                {step === 2 &&
                                    <>
                                        <div className="inquery-form scrollbar">
                                            <Dropdown disabled={window.location.pathname.split("/")[2] ? true : false} objectList items={paymentMethodList} error={step2Errors.filter((name: { path: string; }) => name.path === "payment_method")?.[0]?.errors?.[0]} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-100" lable="نحوه پرداخت حق بیمه " placeholder="  انتخاب کنید " value={payment_method} onChange={(e: any) => this.handleChangePayment(e)} icon={<img src={ChatSquare} alt="هامرز" />} />
                                            <Input hasComma error={step2Errors.filter((name: { path: string; }) => name.path === "premium_annually")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="ریال" iconBorder icon={<Money />} myStyle="inquery-input w-100"
                                            hasNotice={payment_method === 0 ? "میزان حق‌بیمه‌ای که توان و تمایل پرداخت آن را به‌صورت یکجا دارید در این قسمت وارد نمایید." : "میزان حق‌بیمه‌ای که در طول یک سال، توان و تمایل پرداخت آن را دارید در این قسمت وارد نمایید."}
                                            lable={payment_method === 0 ? "حق بیمه  یکجا   " : "حق بیمه سال اول   "} value={premium_annually} onChange={(e: any) => this.setState({ premium_annually: e })} />
                                            <Input disabled={payment_method === 0 ? true : false} hasComma error={step2Errors.filter((name: { path: string; }) => name.path === "saveing")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="ریال" iconBorder icon={<SquareTransferVertical />} myStyle="inquery-input w-100" lable="  آورده اولیه" value={saveing} onChange={(e: any) => this.setState({ saveing: e })} />
                                            <Dropdown hasNotice="جهت خنثی کردن اثر تورمی موجود در کشور می‌توانید سالانه حق‌بیمه خود را به نسبت سال قبل حداکثر تا 50 درصد افزایش دهید." disabled={payment_method === 0 ? true : false} items={limitationInquiry?.filter((item: { name: string; }) => item.name === "adjustment_coefficient_permium")[0]?.values} error={step2Errors.filter((name: { path: string; }) => name.path === "adjustment_coefficient_permium")?.[0]?.errors?.[0]} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-100" lable="افزایش سالانه حق بیمه  (درصد) " placeholder="  انتخاب کنید " value={adjustment_coefficient_permium} onChange={(e: any) => this.setState({ adjustment_coefficient_permium: e.target.value })} icon={<img src={ChatSquare} alt="هامرز" />} />
                                            <Dropdown hasNotice="درصورت تمایل می‌توانید حق‌بیمه‌ی پوشش‌های بیمه‌ای را جداگانه و مستقل از بخش سرمایه‌گذاری پرداخت نمایید." disabled={payment_method !== 0 ? true : false} objectList items={[{ title: "بله", value: true }, { title: "خیر", value: false }]} error={step2Errors.filter((name: { path: string; }) => name.path === "decuple_coverages_premium")?.[0]?.errors?.[0]} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-100" lable="پرداخت جداگانه‌ی حق بیمه پوشش‌های بیمه‌ای" placeholder="  انتخاب کنید " value={decuple_coverages_premium} onChange={(e: any) => this.setState({ decuple_coverages_premium: e.target.value })} icon={<img src={ChatSquare} alt="هامرز" />} />


                                            <Input hasNotice="مدت بیمه‌نامه برابر حداقل 5 سال و حداکثر 30 سال بوده، به‌طوری‌که مدت بیمه‌نامه به اضافه‌ی سن فعلی بیمه‌شده می‌بایست کمتر از 80 سال باشد." error={step2Errors.filter((name: { path: string; }) => name.path === "duration")?.[0]?.errors?.[0]} hideEndAdornment endAdornment="سال" isRequired type="number" iconBorder icon={<img src={History} alt="هامرز" />} myStyle="inquery-input w-100" lable=" مدت بیمه" value={duration} onChange={(e: any) => this.setState({ duration: e })} />
                                            <Input hasNotice="مدت زمانی است که بیمه‌گذار براساس شرایط اقتصادی خود برای پرداخت حق‌بیمه انتخاب می‌کند. مدت پرداخت حق‌بیمه می‌بایست کمتر یا مساوی با مدت بیمه باشد." disabled={payment_method === 0 ? true : false} error={step2Errors.filter((name: { path: string; }) => name.path === "payment_duration")?.[0]?.errors?.[0]} hideEndAdornment endAdornment="سال" isRequired type="number" iconBorder icon={<CardTransfer color="#000000" />} myStyle="inquery-input w-100" lable="مدت پرداخت حق بیمه" value={payment_duration} onChange={(e: any) => this.setState({ payment_duration: e })} />
                                        </div>

                                    </>
                                }
                                {step === 3 &&
                                    <>
                                        <div className="inquery-form  scrollbar">

                                            <Input hasNotice={`سرمایه فوت مبلغی است که اگر بیمه‌شده فوت کند، به فرد یا افرادی که برای دریافت این مبلغ تعیین شده‌اند، پرداخت می‌شود. حداکثر مبلغ سرمایه فوت 50 میلیارد ریال است. 
                                                    ${payment_method === 0 ? "اگر حق‌بیمه را یکجا پرداخت کنید، مبلغ سرمایه فوت حداکثر 10 برابر حق‌بیمه پرداخت‌شده خواهد بود." : " اگر حق‌بیمه را در طول سال به‌صورت قسطی پرداخت می‌کنید، مبلغ سرمایه فوت می‌تواند بین 1 تا 35 برابر مجموع حق‌بیمه‌های یک سال باشد. "}
                                                    `} hasComma error={step3Errors.filter((name: { path: string; }) => name.path === "start_death_asset")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="ریال" iconBorder icon={<SquareTransferVertical />} myStyle="inquery-input w-100" lable={payment_method === 0 ? "سرمایه فوت به هر علت " : "سرمایه فوت به هر علت (سال اول )"} value={start_death_asset} onChange={(e: any) => this.setState({ start_death_asset: e })} />
                                            <Dropdown hasNotice="شما می‌توانید با انتخاب هر یک از درصدهای زیر که می‌بایست کمتر یا مساوی درصد افزایش سالانه حق‌بیمه انتخابی باشد، میزان سرمایه فوت خود را به صورت سالانه افزایش دهید."  items={limitationInquiry?.filter((item: { name: string; }) => item.name === "adjustment_coefficient_death_benefit")[0]?.values} error={step3Errors.filter((name: { path: string; }) => name.path === "adjustment_coefficient_death_benefit")?.[0]?.errors?.[0]} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-100" lable="افزایش سالانه سرمایه فوت (درصد) " placeholder="  انتخاب کنید " value={adjustment_coefficient_death_benefit} onChange={(e: any) => this.setState({ adjustment_coefficient_death_benefit: e.target.value })} icon={<img src={GraphNewUp} alt="هامرز" />} />
                                            <Dropdown contentLoading={contentLoading} objectList error={step3Errors.filter((name: { path: string; }) => name.path === "insurred_extra_dangers")?.[0]?.errors?.[0]} items={extrarisk} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-30" lable="خطرات اضافه   " placeholder="  انتخاب کنید " value={this.state.insurred_extra_dangers}
                                                onChange={(event: any) => this.changeDangerInsured(event.target.value)} icon={<Money />} />
                                            <div className="cover mb-2">
                                                <span className="cover-title">
                                                    پوشش های تکمیلی حادثه
                                                </span>
                                            </div>
                                            <div className=" w-100">
                                                <CustomSelect
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "accident_death_coverage")[0]}
                                                    onChange={(e: any) => this.changeAccidentDeathCoverage(e)}
                                                    value={accident_death_coverage} placeholder="غرامت فوت ناشی از حادثه (برابر) " myStyle="w-100"
                                                    hasNotice="سرمایه‌ای است که هرگاه بیمه‌شده به علت حادثه فوت شود به استفاده‌کننده (گان) به شرط فوت، پرداخت می‌شود. حداقل نسبت این سرمایه (سرمایه فوت در اثر حادثه) به سرمایه فوت به هر علت، 1 و حداکثر 4 برابر است. " />





                                                <CustomSelect onChange={(e: any) => this.setState({ accident_medical_cost_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "accident_medical_cost_coverage")[0]}
                                                    value={accident_medical_cost_coverage} placeholder=" هزینه پزشکی (درصد) " myStyle="w-100" 
                                                    hasNotice="حداکثر معادل 20 درصد از سرمایه فوت به هرعلت که در صورت نیاز بیمه‌شده به خدمات درمانی ناشی از حوادث، به وی تعلق می‌گیرد. "
                                                    disabled={accident_death_coverage === "0" || accident_death_coverage === "" || Number(accident_death_coverage) === 0} />
                                                <CustomSelect onChange={(e: any) => this.setState({ temporary_and_permanent_disability_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "temporary_and_permanent_disability_coverage")[0]}
                                                    value={temporary_and_permanent_disability_coverage} placeholder=" نقص عضو دائم  کلی و جزیی (درصد)  " myStyle="w-100"
                                                    disabled={accident_death_coverage === "0" || accident_death_coverage === "" || Number(accident_death_coverage) === 0} 
                                                    hasNotice="حداکثر معادل 100 درصد از سرمایه فوت به هرعلت که در صورت نقص عضو بیمه‌شده به وی تعلق می‌گیرد. " />

                                                <CustomSelect onChange={(e: any) => this.setState({ has_temporary_disability_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_temporary_disability_coverage")[0]}
                                                    value={has_temporary_disability_coverage} placeholder=" غرامت روزانه عمومی" myStyle="w-100"
                                                    hasNotice="روزانه معادل پنج در هزار سرمایه فوت به هر علت، در دوران ازکارافتادگی موقت بیمه‌شده که بر اثر حادثه ایجاد شده باشد، به وی پرداخت می‌شود"
                                                    disabled={accident_death_coverage === "0" || accident_death_coverage === "" || Number(accident_death_coverage) === 0} />
                                                <CustomSelect onChange={(e: any) => this.setState({ has_hos_benefit_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_hos_benefit_coverage")[0]}
                                                    value={has_hos_benefit_coverage} placeholder="غرامت روزانه بستری" myStyle="w-100"
                                                    hasNotice="روزانه معادل پنج در هزار سرمایه فوت به هر علت، در دوران بستری بيمه شده در مراكز درمانی که بر اثر حادثه ایجاد شده باشد، به وی پرداخت می‌شود. "
                                                    disabled={accident_death_coverage === "0" || accident_death_coverage === "" || Number(accident_death_coverage) === 0} />

                                                <CustomSelect onChange={(e: any) => this.setState({ annuity_disability_coverage_accident: e })}
                                                hasNotice="حداکثر معادل 10 درصد از سرمایه فوت به هر علت که درصورت نقص عضو و ازکارافتادگی دائم کلی بیمه‌شده که بر اثر حادثه ایجاد شده باشد، توسط شرکت بیمه در زمان حیات وی و حداکثر تا پایان مدت بیمه‌نامه به‌صورت مستمری به وی پرداخت خواهد نمود."
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "annuity_disability_coverage_accident")[0]} value={annuity_disability_coverage_accident} placeholder=" پرداخت مستمری ازکارافتادگی دائم (درصد) " myStyle="w-100" />




                                            </div>
                                            <div className="cover mb-2">
                                                <span className="cover-title">
                                                    پوشش های تکمیلی درمان
                                                </span>
                                            </div>
                                            <div className=" w-100">

                                                <CustomSelect onChange={(e: any) => this.handleChangeCancer(e)}
                                                hasNotice="حداکثر معادل 50 درصد از سرمایه فوت به هر علت که درصورت ابتلای بیمه‌شده به سرطان، به وی پرداخت خواهد شد."
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "cancer_coverage")[0]}
                                                    value={cancer_coverage} placeholder="بیماری سرطان (درصد) " myStyle="w-100" />

                                                <CustomSelect

                                                    disabled={cancer_coverage === "0" || cancer_coverage === "" || cancer_coverage === 0}
                                                    onChange={(e: any) => this.setState({ has_cancer_diagnosis: e })}
                                                    hasNotice="معادل 20 درصد از غرامت بیماری سرطان است که جبران هزینه های ناشی از تشخیص سرطان بیمه‌شده، به وی پرداخت می‌گردد. "
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_cancer_diagnosis")[0]}
                                                    value={has_cancer_diagnosis} placeholder="هزینه تشخیص سرطان" myStyle="w-100" />


                                                <CustomSelect onChange={(e: any) => this.setState({ main_special_diseases_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "main_special_diseases_coverage")[0]}
                                                    value={main_special_diseases_coverage} placeholder=" امراض خاص اصلی (درصد) " myStyle="w-100" 
                                                    hasNotice="حداکثر معادل 50 درصد از سرمایه فوت به هر علت است و بیماری‌های مشمول این پوشش عبارت است از مجموعه اعمال تهاجمی قلب، سکته قلبی، سکته مغزی و پیوند اعضای اصلی بدن شامل: قلب، ریه، کبد، کلیه، مغز و استخوان. " />
                                                <CustomSelect
                                                    disabled={main_special_diseases_coverage === "0" || main_special_diseases_coverage === "" || main_special_diseases_coverage === 0}
                                                    onChange={(e: any) => this.setState({ has_supplementary_special_diseases_coverage: e })}
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_supplementary_special_diseases_coverage")[0]}
                                                    hasNotice="حداکثر معادل غرامت امراض خاص اصلی است"
                                                    value={has_supplementary_special_diseases_coverage} placeholder=" امراض خاص تکمیلی" myStyle="w-100" />


                                                <CustomSelect onChange={(e: any) => this.setState({ annuity_disability_coverage_disease: e })}
                                                hasNotice="حداکثر معادل 10 درصد از سرمایه فوت به هر علت که درصورت نقص عضو و ازکارافتادگی دائم کلی بیمه‌شده که بر اثر بیماری ایجاد شده باشد، توسط بیمه‌گر در زمان حیات وی و حداکثر تا پایان مدت بیمه‌نامه به‌صورت مستمری به وی پرداخت خواهد نمود."
                                                    item={limitationInquiry?.filter((item: { name: string; }) => item.name === "annuity_disability_coverage_disease")[0]} value={annuity_disability_coverage_disease} placeholder=" پرداخت مستمری ازکارافتادگی دائم (درصد) " myStyle="w-100" />





                                            </div>




                                        </div>

                                    </>

                                }

                                {step === 4 &&
                                    <div className="inquery-form scrollbar">
                                        <Dropdown disabled={payment_method === 0 || this.state.selfsame ? true : false} objectList error={step4Errors.filter((name: { path: string; }) => name.path === "policy_holder_extra_dangers")?.[0]?.errors?.[0]} items={extrarisk} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-100 mb-4" lable=" خطرات اضافه  " placeholder="  انتخاب کنید " value={this.state.policy_holder_extra_dangers}
                                            onChange={(event: any) => this.changeDangerHolder(event.target.value)} icon={<Money />} />

                                        <CustomSelect disabled={payment_method === 0 ? true : false} onChange={(e: any) => this.setState({ has_waiver_diseases_policy_holder: e })}
                                            item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_waiver_diseases_policy_holder")[0]}
                                            value={has_waiver_diseases_policy_holder} placeholder="معافیت از پرداخت حق بیمه در اثر بیماری" myStyle="w-100  mb-2" 
                                            hasNotice="درصورتی که بیمه‌گذار به دلیل بیماری‌های مشمول این بیمه‌نامه دچار نقص عضو و از کارافتادگی دائم و کامل گردد، از پرداخت حق‌بیمه معاف و شرکت بیمه زندگی هامرز به جای وی اقساط حق‌بیمه را تا پایان مدت بیمه‌نامه یا سن موثر 80 سالگی (هرکدام زودتر بود) پرداخت خواهد کرد. " />
                                        <CustomSelect disabled={payment_method === 0 ? true : false} onChange={(e: any) => this.setState({ has_waiver_accident_policy_holder: e })} 
                                        hasNotice="درصورتی که بیمه‌گذار به دلیل خطرات مشمول این بیمه‌نامه دچار نقص عضو و از کارافتادگی دائم و کامل گردد، از پرداخت حق‌بیمه معاف و شرکت بیمه زندگی هامرز به جای وی اقساط حق‌بیمه را تا پایان مدت بیمه‌نامه یا سن موثر 80 سالگی (هرکدام زودتر بود) پرداخت خواهد کرد. "
                                            item={limitationInquiry?.filter((item: { name: string; }) => item.name === "has_waiver_accident_policy_holder")[0]} value={has_waiver_accident_policy_holder} placeholder=" معافیت از پرداخت حق بیمه در اثر حادثه" myStyle="w-100" />
                                    </div>

                                }
                                {step === 5 &&

                                    <div className="policy w-100 table-responsive my-2">
                                        {life_bens && life_bens.length > 0 ? life_bens?.map((item: any, index: number) => (
                                            <>
                                                <Accordion className="policy-accordion ">
                                                    <AccordionSummary
                                                        expandIcon={<img src={Arrowdown2} alt="هامرز" />}
                                                        aria-controls="panel1a-content"
                                                        className="summsry"
                                                        id="panel1a-header"
                                                    >
                                                        <TableRowResponsive myStyle="col-6" title="ردیف" value={index + 1} />

                                                        <TableRowResponsive myStyle="col-6" title="درصد سهم" value={`${item?.percent}%` || "---"} />
                                                    </AccordionSummary>

                                                    <AccordionDetails
                                                        className="d-flex flex-wrap"
                                                    >
                                                        <TableRowResponsive myStyle="col-6" title="صندوق" value={relationPersonList?.find((element: { value: any; }) => element?.value === item?.project_id)?.title} />
                                                        <TableRowResponsive title=" عملیات " value="حذف" onClick={() => this.removeLifeObj(index, item?.priority)} />

                                                    </AccordionDetails>
                                                    <AccordionDetails
                                                        className="d-flex flex-wrap"
                                                    >

                                                    </AccordionDetails>
                                                </Accordion>

                                            </>

                                        ))
                                            :

                                            <>
                                            <div className="no-gainer">
                                            شما می‌توانید یک، دو یا سه صندوق سرمایه‌گذاری انتخاب کنید، به شرطی که مجموع درصدهای انتخابی شما برابر با 100 درصد باشد.
                                            </div>
                                            {/* <div className="no-gainer">
                                                هیچ صندوقی افزوده نشده
                                            </div> */}
                                            </>

                                        }

                                        {step5Errors.filter((name: { path: string; }) => name.path === "life_bens")?.[0]?.errors?.[0] &&

                                            <label className="custom-input-error mb-2 ">
                                                {step5Errors.filter((name: { path: string; }) => name.path === "life_bens")?.[0]?.errors?.[0]}
                                            </label>

                                        }

                                        <div className="gainer add-fund-btn" onClick={() => this.handleOpenModal()}>
                                            <img src={Add} alt="هامرز" />
                                            <span>
                                                افزودن صندوق
                                            </span>                                                        </div>
                                    </div>

                                }
                                {step !== 1 && this.state.isEdited &&
                                    <div className="inquery-result-btn-group inquery-btn-group">
                                        <Button icon={Tick} myStyle="replay bg-green next-btn" title="اعمال تغییرات" onClick={() => this.increaseSteper(false)} />
                                        <div className="user-dashboard" onClick={() => this.increaseSteper(true)}>

                                            ادامه ویرایش
                                        </div>
                                    </div>


                                }
                                {step !== 1 && !this.state.isEdited &&
                                    <div className="inquery-btn-group">
                                        <Button myStyle="bg-blue next-btn" title="مرحله بعد" onClick={() => this.increaseSteper(true)} />
                                        <Button myStyle="bg-outline-white pre-btn" title="مرحله قبل" onClick={() => this.decreaseSteper()} />
                                    </div>}
                            </div>
                        </>
                    }
                    <CustomModal myStyle="add-beneficiary add-fund" openModal={openBeneficiaryModal} onClose={() => this.handleHideModal()}>
                        <div className="add-beneficiary-container ">
                            <div className="custom-modal-main-title ">
                                <h1 className="title">

                                </h1>
                                <Cancel myStyle="ps-2 hide-desktop" width="20" height="20" color="#000000" onClick={() => this.handleHideModal()} />

                                <Cancel myStyle="hide-mobile cursor-pointer hide-mobile" onClick={() => this.handleHideModal()} />


                            </div>


                            <span className="inquery-title add-beneficiary-title">
                                <span>
                                    افزودن  صندوق
                                </span>
                            </span>


                            <p className="inquery-description">
                                جهت افزودن صندوق اطلاعات زیر را تکمیل نمایید
                            </p>
                            <div className="custom-input mb-0"  >
                                <>
                                    {contentLoading ?
                                        <div className="input-loading-lable content-loading">
                                        </div>
                                        :

                                        <label className="custom-input-lable">
                                            <img src={Star} alt="هامرز" /> یکی از صندوق های زیر را انتخاب کنید
                                        </label>


                                    }
                                </>
                            </div>
                            {!contentLoading &&

                                <div className="slider-container mb-4 px-1">

                                    <Slider {...settings}>
                                        {relationPersonList?.map((item: any, index: number) => {
                                            return (
                                                <div className="mt-2">

                                                    <div className={`${Number(project_id) === Number(item?.value) ? "selected-fund-item" : ""} fund-item`} onClick={() => this.handleChangeRelationId(item?.value)} key={index}>
                                                        {
                                                            Number(project_id) === Number(item?.value) && 
                                                            <img src={CircleTick} className="circle-tick" alt="هامرز" />
                                                        }
                                                        <div className=" fund-item-row"><span className="title">{item?.title}</span>{" "}</div>
                                                        <div>
                                                            <div className=" fund-item-row">
                                                                <span className="value">سود پیش بینی سالیانه : </span>
                                                                <span className="value"> {Math.round(item?.forecast_redeem_value * 100)} درصد</span>
                                                            </div>
                                                            <div className=" fund-item-row">
                                                                <span className="value">سود تضمینی سالیانه  : </span>
                                                                <span className="value"> {Math.round(item?.redeem_value * 100)} درصد </span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </Slider>
                                </div>

                            }
                            <div className="error-text w-100">
                                {step5Errors.filter((name: { path: string; }) => name.path === "project_id")?.[0]?.errors?.[0]}
                            </div>

                            {/* <Dropdown
                                  error={step5Errors.filter((name: { path: string; }) => name.path === "project_id")?.[0]?.errors?.[0]}
                                  myStyle=" custom-modal-item w-100" lable="صندوق" /> */}


                            <div className="custom-modal-row mt-2">
                                <Input max="3" contentLoading={contentLoading} error={step5Errors.filter((name: { path: string; }) => name.path === "percent")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="" iconBorder icon={<img src={ChatSquare} alt="هامرز" />} myStyle="inquery-input custom-modal-item w-100" lable="درصد سهم" value={percent} onChange={(e: any) => this.setState({ percent: e })} />
                            </div>

                            <div className="custom-modal-confirm">
                                {contentLoading ? <>
                                    <div className="content-loading"></div>
                                    <div className="content-loading"></div>
                                </> :
                                    <>

                                        <Button myStyle="bg-blue next-btn" title="ثبت" onClick={() => this.checkObj()} />

                                    </>
                                }
                            </div>
                        </div>
                    </CustomModal>
                    



                    




                </div>
            </Layout>
        )
    }
}

const mapStateToProps = (dispatch: any) => {
    return {
        dispatch,
        unitLinkData: dispatch.general.unitLinkData,
        insuredEqualPolicyHolder: dispatch.general.insuredEqualPolicyHolder,
        userData: dispatch.general.userData,

    };
};
export default connect(mapStateToProps)(Uitlink);
